"use client";
import { Provider } from 'jotai'
import { TRPCReactProvider } from "@/trpc/react";
import { SessionProvider } from '@/lib/auth-client';
import { type Session } from '@/types/auth';
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { ThemedToastContainer } from './ThemedToastContainer';
export const Providers = ({ children, initialSession }: Readonly<{ children: React.ReactNode, initialSession?: Session | null }>) => {
    return (
        <Provider>
            <SessionProvider initialSession={initialSession}>
                <TRPCReactProvider>
                    <NextThemesProvider
                        attribute="class"
                        defaultTheme="system"
                        enableSystem
                        disableTransitionOnChange
                    >
                        <ThemedToastContainer />
                        {children}
                    </NextThemesProvider>
                </TRPCReactProvider>
            </SessionProvider>
        </Provider>
    )
}